{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Yapışdır",
    "pasteAsPlaintext": "Düz mətn kimi yapışdırın",
    "pasteCharts": "Diaqramları yapışdırın",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "Hamısını seç",
    "multiSelect": "Seçimə element əlavə edin",
    "moveCanvas": "Kanvası köçürün",
    "cut": "Kəs",
    "copy": "Kopyala",
    "copyAsPng": "PNG olaraq panoya kopyala",
    "copyAsSvg": "SVG olaraq panoya kopyala",
    "copyText": "Mətn olaraq panoya kopyala",
    "copySource": "Mənbəni kopyala",
    "convertToCode": "Koda çevir",
    "bringForward": "Önə daşı",
    "sendToBack": "Geriyə göndərin",
    "bringToFront": "Önə gətirin",
    "sendBackward": "Geriyə göndərin",
    "delete": "Sil",
    "copyStyles": "Stilləri kopyalayın",
    "pasteStyles": "Stilləri yapışdırın",
    "stroke": "Strok rəngi",
    "changeStroke": "Ştrix rəngini dəyişdir",
    "background": "Arxa fon",
    "changeBackground": "Fon rəngini dəyişdir",
    "fill": "Doldur",
    "strokeWidth": "Strok eni",
    "strokeStyle": "Strok stili",
    "strokeStyle_solid": "Qatı",
    "strokeStyle_dashed": "Kəsik",
    "strokeStyle_dotted": "Nöqtəli",
    "sloppiness": "Səliqəsizlik",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Şəffaflıq",
    "textAlign": "Mətni uyğunlaşdır",
    "edges": "Kənarlar",
    "sharp": "Kəskin",
    "round": "Dəyirmi",
    "arrowheads": "Ox ucları",
    "arrowhead_none": "Heç biri",
    "arrowhead_arrow": "Ox",
    "arrowhead_bar": "Çubuq",
    "arrowhead_circle": "Dairə",
    "arrowhead_circle_outline": "Çevrə (Kontur)",
    "arrowhead_triangle": "Üçbucaq",
    "arrowhead_triangle_outline": "Üçbucaq (kontur)",
    "arrowhead_diamond": "Almaz",
    "arrowhead_diamond_outline": "Almaz (kontur)",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "",
    "cardinality": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Şrift ölçüsü",
    "fontFamily": "Şrift qrupu",
    "addWatermark": "\"Made with Excalidraw\" əlavə et",
    "handDrawn": "Əllə çəkilmiş",
    "normal": "Normal",
    "code": "Kod",
    "small": "Kiçik",
    "medium": "Orta",
    "large": "Böyük",
    "veryLarge": "Çox böyük",
    "solid": "Qatı",
    "hachure": "Ştrix",
    "zigzag": "Ziqzaq",
    "crossHatch": "Çarpaz dəlik",
    "thin": "İncə",
    "bold": "Qalın",
    "left": "Sol",
    "center": "Mərkəz",
    "right": "Sağ",
    "extraBold": "Ekstra qalın",
    "architect": "Memar",
    "artist": "Rəssam",
    "cartoonist": "Karikaturaçı",
    "fileTitle": "Fayl adı",
    "colorPicker": "Rəng seçən",
    "canvasColors": "Kanvas üzərində istifadə olunur",
    "canvasBackground": "Kanvas arxa fonu",
    "drawingCanvas": "Kanvas çəkmək",
    "clearCanvas": "Lövhəni təmizlə",
    "layers": "Qatlar",
    "actions": "Hərəkətlər",
    "language": "Dil",
    "liveCollaboration": "Canlı əməkdaşlıq...",
    "duplicateSelection": "Dublikat",
    "untitled": "Başlıqsız",
    "name": "Ad",
    "yourName": "Adınız",
    "madeWithExcalidraw": "Excalidraw ilə hazırlanmışdır",
    "group": "Qrup şəklində seçim",
    "ungroup": "Qrupsuz seçim",
    "collaborators": "Əməkdaşlar",
    "you": "",
    "toggleGrid": "Toru dəyiş",
    "loadingScene": "Səhnə yüklənir...",
    "loadScene": "Səhnəni fayldan yüklə",
    "align": "Hizala",
    "alignTop": "Yuxarı hizala",
    "alignBottom": "Aşağı hizala",
    "alignLeft": "Sola hizala",
    "alignRight": "Sağa hizala",
    "centerVertically": "Şaquli ortala",
    "centerHorizontally": "Üfüqi ortala",
    "distributeHorizontally": "Üfüqi payla",
    "distributeVertically": "Şaquli payla",
    "flipHorizontal": "Üfüqi çevir",
    "flipVertical": "Şaquli çevir",
    "viewMode": "Görünüş Rejimi",
    "share": "Paylaş",
    "showStroke": "Çevrə rəng seçimini göstər",
    "showBackground": "Fon rəng seçimini göstər",
    "showFonts": "",
    "toggleTheme": "Gecə/Güzdüz rejiminə dəyiş",
    "theme": "Fon",
    "decreaseFontSize": "Şrift ölçüsünü azalt",
    "increaseFontSize": "Şrift ölçüsünü artır",
    "unbindText": "Mətni çıxar",
    "bindText": "Mətni konteynerə qoş",
    "createContainerFromText": "Mətni konteynerə bük",
    "link": {
      "edit": "Keçidi düzəliş et",
      "editEmbed": "",
      "create": "",
      "label": "Keçid",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "",
      "unlock": "",
      "lockAll": "",
      "unlockAll": ""
    },
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "",
    "exportJSON": "",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "",
    "copyLink": "",
    "save": "",
    "saveAs": "",
    "load": "",
    "getShareableLink": "",
    "close": "",
    "selectLanguage": "",
    "scrollBackToContent": "",
    "zoomIn": "",
    "zoomOut": "",
    "resetZoom": "",
    "menu": "",
    "done": "",
    "edit": "",
    "undo": "",
    "redo": "",
    "createNewRoom": "",
    "fullScreen": "",
    "darkMode": "",
    "lightMode": "",
    "systemMode": "Sistem rejimi",
    "zenMode": "Zen rejimi",
    "objectsSnapMode": "Obyektlərə bərkidin",
    "exitZenMode": "Zen rejimindən çıxış",
    "cancel": "Ləğv et",
    "clear": "Təmizlə",
    "remove": "Sil",
    "embed": "Yerləşdirməni aktiv et",
    "submit": "Göndər",
    "confirm": "Təsdiqlə",
    "embeddableInteractionButton": "Əlaqə üçün kliklə"
  },
  "alerts": {
    "clearReset": "Bu, bütün lövhəni təmizləyəcək. Sən əminsiniz?",
    "couldNotCreateShareableLink": "Paylaşıla bilən keçid yaratmaq mümkün olmadı.",
    "couldNotCreateShareableLinkTooBig": "Paylaşıla bilən link yaratmaq mümkün olmadı. Səhnə çox böyükdür",
    "couldNotLoadInvalidFile": "Faylı açmaq müknü olmadı",
    "importBackendFailed": "İdxal zamanı xəta baş verdi.",
    "cannotExportEmptyCanvas": "Boş lövhəni ixrac etmək mümkün deyil.",
    "couldNotCopyToClipboard": "Kopyalana bilmədi.",
    "decryptFailed": "Məlumatın şifrəsini açmaq mümkün olmadı.",
    "uploadedSecurly": "Yükləmə end-to-end şifrələmə texnologiyası ilə qorunub, yəni Excalidraw serveri və üçüncü tərəflər məzmunu oxuya bilməz.",
    "loadSceneOverridePrompt": "Xarici rəsmin yüklənməsi mövcud məzmununuzu əvəz edəcək. Davam etmək istəyirsiniz?",
    "collabStopOverridePrompt": "Sessiyanın dayandırılması əvvəlki, yerli olaraq saxlanılan çertyojunuzun üzərinə yazılacaq. Əminsiniz?",
    "imageDoesNotContainScene": "Bu təsvirdə heç bir səhnə məlumatı yoxdur. İxrac zamanı səhnə yerləşdirməni aktiv etmisiniz?",
    "cannotRestoreFromImage": "Səhnəni bu şəkil faylından bərpa etmək mümkün olmadı",
    "invalidSceneUrl": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "",
    "imageInsertError": "",
    "fileTooBig": "",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "",
    "lasso": "",
    "image": "",
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "lock": "",
    "penMode": "",
    "link": "",
    "eraser": "",
    "frame": "",
    "embeddable": "",
    "laser": "",
    "autoshape": "",
    "bucketfill": "",
    "hand": "",
    "extraTools": "",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "",
    "selectedShapeActions": "",
    "shapes": ""
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "",
    "text": "",
    "embeddable": "",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "",
    "canvasTooBig": "",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "",
    "button_stopSession": "",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": ""
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "",
    "click": "",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "",
    "drag": "",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "shapes": "",
    "height": "",
    "scene": "",
    "selected": "",
    "storage": "",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "",
    "version": "",
    "versionCopy": "",
    "versionNotAvailable": "",
    "width": ""
  },
  "toast": {
    "copyStyles": "",
    "copyToClipboard": "",
    "copyToClipboardAsPng": "",
    "copyToClipboardAsSvg": "",
    "fileSaved": "",
    "fileSavedToFilename": "",
    "canvas": "",
    "selection": "",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": "",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
